import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
// import { FunctionService } from 'vhobjects-service';
import { FunctionService } from 'vhobjects-service';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { MatDialog } from '@angular/material/dialog';
import { ColorContrastComponent } from '../../../../../color-contrast/color-contrast.component';

@Component({
  selector: 'atw-button-show-modal-detail-admin-config',
  templateUrl: './button-show-modal-detail-admin-config.component.html',
  styleUrls: ['./button-show-modal-detail-admin-config.component.scss']
})
export class AtwButtonShowModalDetailAdminConfig extends AtwUpdateDbComponent implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() type: any;

  deviceWidth: number; // độ rộng của thiết bị
  deviceHeight: number; // độ cao của thiết bị
  devicePositionTop: number; // vị trí từ top của thiết bị
  devicePositionLeft: number; // vị trí từ left của thiết bị
  devicePositionRight: number; // vị trí từ right của thiết bị
  devicePositionBottom: number; // vị trí từ bottom của thiết bị

  isOpen: boolean = false; // biến kiểm tra đã mở hộp thoại hay chưa

  isCollapsed: boolean = false;
  currentViewAll: any = {};
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  id_subproject: any;
  arr_link_page: any;
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  style_color: string = ''; // biến này lấy giá trị của màu rgb và alpha;
  isOpenOptionsBorder: boolean = false;
  fonts = [];
  backgroundColor: any = [];
  effect_hover: any = [];
  effect_hover_data: any = {}
  customize = [];
  block_modal = [];
  devicePosition:any = {};
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'mac_dinh',
      deg: '180deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top,',
      name: 'tu_duoi_len_tren',
      deg: '0deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'tu_trai_sang_phai',
      deg: '90deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'tu_phai_sang_trai',
      deg: '270deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom right,',
      name: 'tu_trai_tren_sang_phai_duoi',
      deg: '135deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom left,',
      name: 'tu_phai_tren_sang_trai_duoi',
      deg: '225deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top right,',
      name: 'tu_trai_duoi_sang_phai_tren',
      deg: '45deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top left,',
      name: 'tu_phai_duoi_sang_trai_tren',
      deg: '315deg',
    },
  ];
  styles_field = [
    {
      title: 'dieu_chinh_noi_dung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_nut_bam',
      index: 2,
    },
    {
      title: 'hieu_ung_chuyen_dong',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
  ];
  width = 0;
  height = 0;
  detailblock: any = {}
  subproject: any;
  parentBlock: any = {}; // block cha của object của để thay đổi z-index khi mở hộp thoại để không bị các block khác đè lên
  zIndexParentBlock: number = 1;
  configMode: 'basic' | 'advanced' = 'basic';
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    private matDialog: MatDialog,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
    this.subproject = this.vhQueryAutoWeb.getlocalSubProject(
      this.vhQueryAutoWeb.getlocalSubProject_Working()._id
    ); 
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/button.json'),
      this.http.get('assets/background-colors/background-colors.json'),
      this.http.get('assets/fonts/fonts.json'),
    ]).subscribe(([effects, background_colors, fonts]: any) => {
      this.fonts = fonts;
      this.effect_hover = effects;
      this.backgroundColor = background_colors;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    });
    
    this.getDetailBlock()
    
  }

  ngOnChanges({ device }: SimpleChanges): void {
    if (!this.staticdata.accessibility) this.staticdata.accessibility = {}; 
    
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }

    this.width = document.getElementById(this.objectChoosing._id).clientWidth;
    this.height = document.getElementById(this.objectChoosing._id).clientHeight;
  }




  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['btn-modal__boundary']['background-image'] = "linear-gradient(" + this.config['background-color']['gradient_direction'] + this.config['background-color']['gradient_arr'] + ")";
    }
    else {
      this.class['btn-modal__boundary']['background-image'] = 'none';
    }

    this.updateObject();
  }

  /**
 * Lấy vị trí của thiết bị
 */
  resolution
  getDeviceData() {
    this.resolution = this.vhQueryAutoWeb.getlocalSubProject(
      this.vhQueryAutoWeb.getlocalSubProject_Working()._id
    ).resolution;
    let currentDevice = document.querySelector(`#page-design`).children[0]
    let bodyOutletEle = document.querySelector(`.body-outlet`);
    if (currentDevice) {
      const rect = currentDevice.getBoundingClientRect();
      this.deviceWidth = rect.width;
      this.deviceHeight = bodyOutletEle.clientHeight - 80;

      this.devicePosition = {
        top: rect.top,
        left: rect.left,
        right: window.innerWidth - rect.right,
        bottom: 16,
      }
    }
    }

  /**
  * Lấy ra các block.
  */
    getDetailBlock() {
      if (this.objectChoosing.staticdata.id_freeblock )
        this.vhQueryAutoWeb
          .getDetailBlock(this.objectChoosing.staticdata.id_freeblock)
          .then(
            (detailblock) => {
              if(detailblock) {
                this.detailblock = detailblock;
                this.getBlockClick();
              }
            },
            (error) => {
              
            }
          );
    }



  /**
 * bắt sk thay đổi vị trị popup
 */
  handlePositionPopup(positionUnSet: string, positionSet: string) {
    if (positionSet === 'center') {
      this.class['btn-modal__popup']['left'] = "50%"
      this.class['btn-modal__popup']['transform'] = "translateX(-50%)"

      this.class['btn-modal__popup']['right'] = "unset";
    } else {
      this.class['btn-modal__popup'][positionUnSet] = "unset"
      this.class['btn-modal__popup'][positionSet] = '0';
      this.class['btn-modal__popup']['transform'] = "unset"

    }
    this.updateClass()
  }

  // /**
  //  * Hàm update object vào database.
  //  */
  //  updateObject() {
  //    return this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { 
  //      [this.device + '_class']: this.class, 
  //      [this.device + '_config']: this.config, 
  //      staticdata: this.staticdata })
  //      .then((bool: any) => {
        
  //      })
  //  }

  // /**
  //  * Hàm update class
  //  */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
        
  //     })
  // }

  // /**
  //  * Hàm update config
  //  */
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //     .then((bool: any) => {
        
  //     })
  // }

  
  // /**
  //  * Cập nhật staticdata vào database.
  //  */
  // updateStaticData() {
  //   // Gọi hàm truy vấn cơ sở dữ liệu ở đây
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
  //   .then((bool) => {
  //   });
  //   this.updateDimension()
  // }

  /**
   * hàm này để update width height trong dimention của config  
   */
  updateDimension(){
    this.width = document.getElementById(this.objectChoosing._id).clientWidth;
    this.height = document.getElementById(this.objectChoosing._id).clientHeight;
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.config = {
      ...this.config,
      dimension: {
        width: Number(Number(this.width).toFixed(2)),
        height: Number(Number(this.height).toFixed(2))
      }
    }
    this.updateConfig();
  } 

  /**
   * remove link khi click vào nút x
   */
  removeLink() {
    this.staticdata.hyper_link = '';
    this.updateStaticData();
  }
  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /**Xử lý lấy thông số giá trị background color.
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundColor(e) {
    // lấy giá trị tham số event của thanh slide khi thay đổi.
    this.valueParameter = e.target.value;
    // Tính giá trị alpha cho màu rgb.
    const data =
      this.device === 'desktop'
        ? this.class['btn-modal__boundary']
        : this.class['btn-modal__boundary'];
    // Nối chuỗi màu + độ mờ (alpha) và lưu vào database.
    this.style_color = `rgba(${this.hexToRGB(data.background)}, ${this.config['background-color']['value_range'] / 100
      })`;
    data.background_rgb = this.style_color;
    this.updateClass();
  }
  /**Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    // lấy giá trị tham số event của thanh slide khi thay đổi.
    this.valueParameter = e.target.value;
    if (this.device == 'desktop') {
      // Tính giá trị alpha cho màu rgb.
      this.config['background-color']['value_parameter'] = this.valueParameter;
      this.config['background-color']['value_range'] =
        this.valueParameter / 100;
      // Tách các phần tử màu từ chuỗi rgba.
      const newArr = this.config['background-color'].arr_gradient.map(
        (color) => {
          const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
          return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-color']['value_range']})`;
        }
      );
      // return giá trị chuỗi màu gradient và lưu vào database.
      this.config['background-color'].arr_gradient = newArr;
      this.updateBackgroundRgb();
    } else {
      // Tính giá trị alpha cho màu rgb.
      this.config['background-color']['value_parameter'] = this.valueParameter;
      this.config['background-color']['value_range'] =
        this.valueParameter / 100;
      const newArr = this.config['background-color'].arr_gradient.map(
        (color) => {
          // Tách các phần tử màu từ chuỗi rgba
          const parts = color.match(/(\d+(\.\d+)?)/g);
          return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-color']['value_range']})`;
        }
      );
      // return giá trị chuỗi màu gradient và lưu vào database.
      this.config['background-color'].arr_gradient = newArr;
      this.updateClass();
    }
  }
  /**Hàm này dùng để click chọn màu nền của danh sách màu.
   * @param bgColor : trả về màu được chọn
   * @param event : trả về element được active
   */
  chooseBg(bgColor, event) {
    // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
    // Lấy ra element màu được click từ tham số event trả về.
    var activeGradient = document.querySelector('.container-color .active') as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');

    // Chuyển đổi màu được click thành mã rgb, thêm alpha vào mã rgb và lưu vào database.
    this.class['btn-modal__boundary']['background-color'] =
      `rgba(${this.hexToRGB(bgColor.bgColor)}, ${this.config['background-color'].range_value ?? 1})`;

    this.updateObject();
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    // Get class active của element khi click chọn hướng phối màu.
    // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
    var activeGradient = document.querySelector('.active') as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');

    this.config['background-color'].gradient_type = direction.type;
    this.config['background-color'].gradient_direction = direction.direction;
    this.class['btn-modal__boundary']['background'] =
      this.config['background-color'].gradient_type +
      '(' +
      this.config['background-color'].gradient_direction +
      this.config['background-color'].gradient_arr.join(',') +
      ')';
    this.updateConfig();
    this.updateClass();
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient =
        this.device == 'desktop'
          ? this.config['background-color']
          : this.config['background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.range_value})`
      );
      this.updateBackgroundRgb();
    }
  }
  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index) {
    if (this.config['background-color'][`gradient_arr`].length > 1) {
      this.config['background-color'][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb();
    }
  }
  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }
  getBlockClick() {
    if(!this.detailblock) return;
    this.vhQueryAutoWeb.getBlocks_byFields({ type: { $eq: this.detailblock.type } })
      .then((blocks: any) => {
        this.block_modal = blocks;
      })
  }
  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu10: false,
    menu11: false,
    menu12: false,
    menu13: false,
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
  *Hàm update class vào database, và gửi cập nhật width, height cho object-selected
  */
  updateClassAndWidthHeight() {
    this.width = document.getElementById(this.objectChoosing._id).clientWidth;
    this.height = document.getElementById(this.objectChoosing._id).clientHeight;
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass();
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[2])
  }


  handlePositionDrawer(align) {
    this.isOpen = false;
    this.handleShowDialog(false);

    switch (align) {
      case 'top':
        this.config['block_position'] = 'top';
        this.class['btn-modal__drawer--wrapper']['right'] = 'unset';
        this.class['btn-modal__drawer--wrapper']['left'] = 'unset';
        this.class['btn-modal__drawer--wrapper']['top'] = '-100%';
        this.class['btn-modal__drawer--wrapper']['bottom'] = 'unset';
        if (!this.popup) return;
        this.popup.children[0].style.top = '-100%';
        this.popup.children[0].style.left = 'unset';
        this.popup.children[0].style.right = 'unset';
        this.popup.children[0].style.bottom = 'unset';

        break;
      case 'bottom':
        this.config['block_position'] = 'bottom';
        this.class['btn-modal__drawer--wrapper']['right'] = 'unset';
        this.class['btn-modal__drawer--wrapper']['left'] = 'unset';
        this.class['btn-modal__drawer--wrapper']['top'] = 'unset';
        this.class['btn-modal__drawer--wrapper']['bottom'] = '-100%';
        if (!this.popup) return;
        this.popup.children[0].style.top = 'unset';
        this.popup.children[0].style.left = 'unset';
        this.popup.children[0].style.right = 'unset';
        this.popup.children[0].style.bottom = '-100%';

        break;
      case 'left':
        this.config['block_position'] = 'left';
        this.class['btn-modal__drawer--wrapper']['left'] = '-100%';
        this.class['btn-modal__drawer--wrapper']['right'] = 'unset';
        this.class['btn-modal__drawer--wrapper']['top'] = 'unset';
        this.class['btn-modal__drawer--wrapper']['bottom'] = 'unset';
        if (!this.popup) return;
        this.popup.children[0].style.top = 'unset';
        this.popup.children[0].style.left = '-100%';
        this.popup.children[0].style.right = 'unset';
        this.popup.children[0].style.bottom = 'unset';
        break;
      case 'right':
        this.config['block_position'] = 'right';
        this.class['btn-modal__drawer--wrapper']['right'] = '-100%';
        this.class['btn-modal__drawer--wrapper']['left'] = 'unset';
        this.class['btn-modal__drawer--wrapper']['top'] = 'unset';
        this.class['btn-modal__drawer--wrapper']['bottom'] = 'unset';
        if (!this.popup) return;
        this.popup.children[0].style.top = 'unset';
        this.popup.children[0].style.left = 'unset';
        this.popup.children[0].style.right = '-100%';
        this.popup.children[0].style.bottom = 'unset';
        break;
    }


    this.updateObject();
  }


  popup
  handleShowDialog(isOpen: boolean) {
    // cách hiên thị show modal ở thiết bị desktop và tablet_landscape giống nhau
    if (this.config['type_show_block'] == 'popup') {
      if (isOpen) {
        // open
        this.class['btn-modal__popup']['opacity'] = 1;
        this.class['btn-modal__popup']['visibility'] = 'visible';
        this.class['btn-modal__popup']['transition'] = 'all 0.3s linear';
        this.class['btn-modal__popup']['pointer-events'] = 'auto';
      }
      else {
        // close
        this.class['btn-modal__popup']['opacity'] = 0;
        this.class['btn-modal__popup']['visibility'] = 'hidden';
        this.class['btn-modal__popup']['pointer-events'] = 'none';

        setTimeout(() => {
          this.class['btn-modal__popup']['transition'] = '0s';
        }, 300);
      }
    }
    else {
      this.getDeviceData();
      var btnModal = document.getElementById(this.objectChoosing._id);
      if (!this.popup) this.popup = btnModal?.querySelector<HTMLElement>('.btn-modal__drawer');
      if (!this.popup) return;
      const blockPosition = this.config['block_position']; // top, bottom, left, right
      let blockClassWidthHeight = document.getElementById(this.staticdata.id_freeblock);

      if (isOpen) {
        // 2. Append vào body nếu chưa có
        document.body.appendChild(this.popup);
        // Mở
        this.popup.style.top = this.devicePosition.top + 'px';
        this.popup.style.left = this.devicePosition.left + 'px';
        this.popup.style.width = this.deviceWidth + 'px';
        this.popup.style.height = this.deviceHeight + 'px';
        this.popup.style.opacity = '1';
        this.popup.style.visibility = 'visible';
        this.popup.style.pointerEvents = 'auto';
        this.popup.style.overflow = 'hidden';
        this.popup.children[0].style.position = 'absolute'

        if (['left', 'right'].includes(blockPosition)) {
          this.popup.children[0].style.width = this.detailblock[this.device + '_position_']['width'] + 'px';
          this.popup.children[0].style.height = this.deviceHeight + 'px';
          this.popup.children[0].style.backgroundColor = this.detailblock[this.device + '_class']['block-blank']['background-color']
          if (blockClassWidthHeight) {
            blockClassWidthHeight.style['min-height'] = '100%';
          }
        } else {
          this.popup.children[0].style.width = this.deviceWidth + 'px';
          this.popup.children[0].style.height = this.detailblock[this.device + '_position_']['height'] + 'px';
          if (blockClassWidthHeight) {
            blockClassWidthHeight.style['width'] = '100%';
          }
        }

        if (this.detailblock[this.device + '_config']['block-blank']['isScroll']) this.popup.children[0].style.overflowY = 'auto';

        setTimeout(() => {
          this.popup.children[0].style[blockPosition] = 0 + 'px';
          this.popup.children[0].style.opacity = '1';
          this.popup.children[0].style.visibility = 'visible';
        });

      }
      else {
        // Đóng
        if (['left', 'right'].includes(blockPosition)) {
          this.popup.children[0].style[blockPosition] = - this.detailblock[this.device + '_position_']['width'] + 'px';
        } else {
          this.popup.children[0].style[blockPosition] = - this.detailblock[this.device + '_position_']['height'] + 'px';
        }


        // này để hiệu ứng đóng của wrapper chạy xong thì mới ẩn lớp phủ vì ẩn ngay sẽ bị giật
        setTimeout(() => {
          this.popup.style.opacity = '0';
          this.popup.style.visibility = 'hidden';
          this.popup.style.pointerEvents = 'none';

          // Khi đóng
          if (this.popup.parentNode) {
            this.popup.parentNode.removeChild(this.popup);
          }
        }, 300);
      }
    }
  }
  
  /**
   * Mở popup so sánh màu nền và màu chữ có tương phản hay không
   * (Để tối ưu Accessibility trong SEO)
   */
  openColorContrast() {
    const colorClass = this.class['btn-modal__boundary__content'].color ? 'btn-modal__boundary__content' : 'btn-modal__boundary';
    const dialogRef = this.matDialog.open(ColorContrastComponent, {
      width: '30vw',
      height: 'fit-content',
      data: {
        /** Chứa map màu nền và màu chữ/icon */
        colorContrast: {
          typeFgColor: 'text',
          textOrIconColor: this.class[colorClass].color,
          bgColor: this.class['btn-modal__boundary']['background-color'],
        }
      },
    });

    dialogRef.afterClosed().subscribe((colorContrast) => {
      if (colorContrast) {
        this.class[colorClass].color = colorContrast.textOrIconColor;
        this.class['btn-modal__boundary']['background-color'] = colorContrast.bgColor;
        this.updateClass();
      }
    });
  }

  /**
   * Update nội dung 
   * @param fieldContent - Tên trường để cập nhật nội dung
   * @param isAriaLabel - Có phải là trường dạng aria-label không
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent(fieldContent, isAriaLabel = false) {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        isAriaLabel 
        ? this.staticdata.accessibility?.[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
        : this.staticdata[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            // Trường hợp là content nằm trong staticdata và nằm bằng cấp với accessibility
            if (!isAriaLabel) {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            } 
            // Trường hợp là field nằm trong accessibility
            else {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata.accessibility?.[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata.accessibility[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }
}
